import React from 'react'

import { AppliedDiscount } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useSelector, useDispatch } from 'react-redux'

import { CHECKOUT_TRACKING_EVENTS } from 'features/checkout/constants'
import { trackEvent as trackCOEvent } from 'features/checkout/duck/operations'
import { VOUCHERS_LOCATION } from 'features/vouchers/constants'
import { operationDeleteVouchers } from 'features/vouchers/duck/operations'
import selectors from 'features/vouchers/duck/selectors'
import { Voucher } from 'features/vouchers/types'

import styles from './AppliedDiscounts.scss'

export interface AppliedDiscountsProps {
  location?: string
}

const AppliedDiscounts: React.FC<AppliedDiscountsProps> = ({ location }) => {
  const dispatch = useDispatch()
  const appliedDiscounts = useSelector(selectors.getAppliedDiscounts)

  const isCheckout = location === VOUCHERS_LOCATION.checkout
  const removeDiscount = (voucherCode: string): void => {
    if (isCheckout) {
      dispatch(
        trackCOEvent({
          event: CHECKOUT_TRACKING_EVENTS.removeDiscountCode.id,
          add: {
            discount_code: voucherCode,
            dep_variable_name: ['discount_code'],
            dep_variable_format: ['string'],
          },
        }),
      )
    }
    dispatch(operationDeleteVouchers(voucherCode, location, true))
  }

  if (appliedDiscounts.length === 0) {
    return null
  }

  return (
    <ul className={styles.container}>
      {appliedDiscounts.map(
        (discount: Voucher): React.ReactElement => (
          <li key={discount.voucherCode} aria-live="polite">
            <AppliedDiscount
              className={styles.appliedDiscount}
              discount={discount}
              isAdditionalDiscountText={
                process.env.IS_DISCOUNT_FORM_ADDITIONAL_TEXT_ENABLED === 'enabled'
              }
              ariaLabelForRemove={`${getLabelFromStorage('sidecart.remove')} ${
                discount.voucherCode
              }`}
              discountInfoText={getLabelFromStorage('checkout.discounts.code.applied.text', {
                replacements: discount.name,
              })}
              onRemove={removeDiscount}
              isTrashIcon={process.env.IS_DISCOUNT_FORM_TRASH_ICON_ENABLED === 'enabled'}
            />
          </li>
        ),
      )}
    </ul>
  )
}

export default AppliedDiscounts
